(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6bCCL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4811bb1c9b570b64$export$6503ec6e8aabbaf; }, function (v) { return $4811bb1c9b570b64$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4811bb1c9b570b64$export$f7ad0328861e2f03; }, function (v) { return $4811bb1c9b570b64$export$f7ad0328861e2f03 = v; });
var $4811bb1c9b570b64$export$6503ec6e8aabbaf;
var $4811bb1c9b570b64$export$f7ad0328861e2f03;
"use strict";
var $4811bb1c9b570b64$var$mapping = new Map();
function $4811bb1c9b570b64$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4811bb1c9b570b64$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4811bb1c9b570b64$var$resolve(id) {
    var resolved = $4811bb1c9b570b64$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4811bb1c9b570b64$export$6503ec6e8aabbaf = $4811bb1c9b570b64$var$register;
$4811bb1c9b570b64$export$f7ad0328861e2f03 = $4811bb1c9b570b64$var$resolve;

});

parcelRegister("fCnh5", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $b5ec75749f6d674c$export$bdfd709ae4826697; }, function (v) { return $b5ec75749f6d674c$export$bdfd709ae4826697 = v; });
var $b5ec75749f6d674c$export$bdfd709ae4826697;
var $b5ec75749f6d674c$export$c9e73fbda7da57b6;
var $b5ec75749f6d674c$export$5a759dc7a1cfb72a;
"use strict";
var $b5ec75749f6d674c$var$bundleURL = {};
function $b5ec75749f6d674c$var$getBundleURLCached(id) {
    var value = $b5ec75749f6d674c$var$bundleURL[id];
    if (!value) {
        value = $b5ec75749f6d674c$var$getBundleURL();
        $b5ec75749f6d674c$var$bundleURL[id] = value;
    }
    return value;
}
function $b5ec75749f6d674c$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $b5ec75749f6d674c$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $b5ec75749f6d674c$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $b5ec75749f6d674c$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$b5ec75749f6d674c$export$bdfd709ae4826697 = $b5ec75749f6d674c$var$getBundleURLCached;
$b5ec75749f6d674c$export$c9e73fbda7da57b6 = $b5ec75749f6d674c$var$getBaseURL;
$b5ec75749f6d674c$export$5a759dc7a1cfb72a = $b5ec75749f6d674c$var$getOrigin;

});

parcelRegister("7ypZT", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("cIcNK")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("jqVVy")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("pNGKa"))
]).then(()=>parcelRequire('h0w1z'));

});
parcelRegister("d7xei", function(module, exports) {
"use strict";

var $fySXl = parcelRequire("fySXl");
module.exports = $fySXl(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("fySXl", function(module, exports) {
"use strict";
var $b544a9276db09370$var$cachedBundles = {};
var $b544a9276db09370$var$cachedPreloads = {};
var $b544a9276db09370$var$cachedPrefetches = {};
function $b544a9276db09370$var$getCache(type) {
    switch(type){
        case 'preload':
            return $b544a9276db09370$var$cachedPreloads;
        case 'prefetch':
            return $b544a9276db09370$var$cachedPrefetches;
        default:
            return $b544a9276db09370$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $b544a9276db09370$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("1So7U", function(module, exports) {


module.exports = (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("j8uYq")).then(()=>parcelRequire('gDnyr'));

});

parcelRegister("9dpCP", function(module, exports) {


module.exports = (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("1hgkd")).then(()=>parcelRequire('l6An8'));

});

parcelRegister("2LfVE", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kcpzp"))((parcelRequire("6bCCL")).resolve("6PvPj")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("eaQQP")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("30dYe"))
]).then(()=>parcelRequire('btVOq'));

});
parcelRegister("kcpzp", function(module, exports) {
"use strict";

var $fySXl = parcelRequire("fySXl");
module.exports = $fySXl(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("6KrIL", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("kcpzp"))((parcelRequire("6bCCL")).resolve("8wKne")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("6rC82"))
]).then(()=>parcelRequire('38v0q'));

});

parcelRegister("4RQ3x", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("cIcNK")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("jqVVy")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("Ntc3V"))
]).then(()=>parcelRequire('kJLhH'));

});

parcelRegister("emBRT", function(module, exports) {


module.exports = (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("gsULD")).then(()=>parcelRequire('9Rn4e'));

});

parcelRegister("6kBOP", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("jqVVy")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("ctqu5"))
]).then(()=>parcelRequire('d37Ct'));

});

parcelRegister("jaaKv", function(module, exports) {


module.exports = (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("7Q0cJ")).then(()=>parcelRequire('cV6ox'));

});

parcelRegister("14i02", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kcpzp"))((parcelRequire("6bCCL")).resolve("2XZfe")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("eaQQP")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("eXfwl"))
]).then(()=>parcelRequire('kgl66'));

});

parcelRegister("6YOpF", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kcpzp"))((parcelRequire("6bCCL")).resolve("8AO03")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("eaQQP")),
    (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("DFlHU"))
]).then(()=>parcelRequire('bSd99'));

});

parcelRegister("4rNzL", function(module, exports) {


module.exports = (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("bLehZ")).then(()=>parcelRequire('k4Nim'));

});

parcelRegister("8Mkvx", function(module, exports) {


module.exports = (parcelRequire("d7xei"))((parcelRequire("6bCCL")).resolve("kRY8c")).then(()=>parcelRequire('hau5w'));

});

var $df16be8850dc70b5$exports = {};


(parcelRequire("6bCCL")).register((parcelRequire("fCnh5")).getBundleURL('iQF0o'), JSON.parse("[\"iQF0o\",\"app.js\",\"pNGKa\",\"parallax.c11331a7.js\",\"jqVVy\",\"parallax.1232e73b.js\",\"cIcNK\",\"parallax.02615c7a.js\",\"j8uYq\",\"animated-grid.eb5a5a46.js\",\"1hgkd\",\"posts-row.abffce1b.js\",\"30dYe\",\"testimonials-slider.43e5532f.js\",\"eaQQP\",\"testimonials-slider.0f864dd6.js\",\"6PvPj\",\"testimonials-slider.1efa6660.css\",\"6rC82\",\"case-studies-slider.edcee72c.js\",\"8wKne\",\"case-studies-slider.8fb311a4.css\",\"Ntc3V\",\"dual-image.c42a87ee.js\",\"gsULD\",\"accordions.60ea27d1.js\",\"ctqu5\",\"methodology.a5932472.js\",\"7Q0cJ\",\"careers-greenhouse-filters.7946e741.js\",\"eXfwl\",\"image-text-slider.35763930.js\",\"2XZfe\",\"image-text-slider.2bb5f576.css\",\"DFlHU\",\"vertical-slider.f2b351ec.js\",\"8AO03\",\"vertical-slider.00c2f808.css\",\"bLehZ\",\"results-filters.65e7e510.js\",\"kRY8c\",\"post-progress-bar.6ff9d95e.js\",\"02yUG\",\"app.css\"]"));


/**
 * Parallax block
 */ const $26f5d5cd93fe655a$var$parallaxElement = document.querySelectorAll(".praxent_parallax");

if ($26f5d5cd93fe655a$var$parallaxElement.length > 0) (parcelRequire("7ypZT")).then((module)=>{
    $26f5d5cd93fe655a$var$parallaxElement.forEach((element)=>{
        module.parallaxHandler(element);
    });
});
/**
 * Animated grid block
 */ const $26f5d5cd93fe655a$var$animatedGridElement = document.querySelectorAll(".praxent_animated-grid");

if ($26f5d5cd93fe655a$var$animatedGridElement.length > 0) (parcelRequire("1So7U")).then((module)=>{
    $26f5d5cd93fe655a$var$animatedGridElement.forEach((element)=>{
        module.animatedGridHandler(element);
    });
});
/**
 * Animated row block
 */ const $26f5d5cd93fe655a$var$animatedRowElement = document.querySelectorAll(".praxent_posts-row");

if ($26f5d5cd93fe655a$var$animatedRowElement.length > 0) (parcelRequire("9dpCP")).then((module)=>{
    $26f5d5cd93fe655a$var$animatedRowElement.forEach((element)=>{
        module.animatedRowHandler(element);
    });
});
/**
 * Testimonials block
 */ const $26f5d5cd93fe655a$var$testimonialsBlock = document.querySelectorAll(".praxent_testimonials .swiper");

if ($26f5d5cd93fe655a$var$testimonialsBlock.length > 0) (parcelRequire("2LfVE")).then((module)=>{
    $26f5d5cd93fe655a$var$testimonialsBlock.forEach((element)=>{
        module.scrollTo(element);
        module.testimonialsSlider(element);
    });
});
/**
 * Case studies block
 */ const $26f5d5cd93fe655a$var$caseStudiesBlock = document.querySelectorAll(".praxent_case-studies .slider");

if ($26f5d5cd93fe655a$var$caseStudiesBlock.length > 0) (parcelRequire("6KrIL")).then((module)=>{
    $26f5d5cd93fe655a$var$caseStudiesBlock.forEach((element)=>{
        module.caseStudiesSlider(element);
    });
});
/**
 * Dual image block
 */ const $26f5d5cd93fe655a$var$dualImageBlock = document.querySelectorAll(".praxent_dual-image");

if ($26f5d5cd93fe655a$var$dualImageBlock.length > 0) (parcelRequire("4RQ3x")).then((module)=>{
    $26f5d5cd93fe655a$var$dualImageBlock.forEach((element)=>{
        module.dualImage(element);
    });
});
/**
 * Plusminus toggler
 */ const $26f5d5cd93fe655a$var$plusminus = document.querySelectorAll(".plusminus");
$26f5d5cd93fe655a$var$plusminus.forEach((elem)=>{
    elem.addEventListener("click", (evt)=>{
        evt.target.classList.toggle("active");
    });
});
/**
 * Accordion toggler
 */ const $26f5d5cd93fe655a$var$accordionBlocks = document.querySelectorAll(".praxent_accordion");
const $26f5d5cd93fe655a$var$faqsBlocks = document.querySelectorAll(".praxent_faqs");
const $26f5d5cd93fe655a$var$methodologyBlock = document.querySelectorAll(".methodology_accordion");

if ($26f5d5cd93fe655a$var$accordionBlocks.length > 0) (parcelRequire("emBRT")).then((module)=>{
    $26f5d5cd93fe655a$var$accordionBlocks.forEach((element)=>{
        module.accordionHandler(element);
    });
});

if ($26f5d5cd93fe655a$var$faqsBlocks.length > 0) (parcelRequire("emBRT")).then((module)=>{
    $26f5d5cd93fe655a$var$faqsBlocks.forEach((element)=>{
        module.accordionHandler(element);
    });
});

if ($26f5d5cd93fe655a$var$methodologyBlock.length > 0) (parcelRequire("6kBOP")).then((module)=>{
    $26f5d5cd93fe655a$var$methodologyBlock.forEach((element)=>{
        module.methodologyAccordionHandler(element);
    });
});
/**
 * Job openings filters
 */ const $26f5d5cd93fe655a$var$jobOpeningsBlocks = document.querySelectorAll(".praxent_job-openings");

if ($26f5d5cd93fe655a$var$jobOpeningsBlocks.length > 0) (parcelRequire("jaaKv")).then((module)=>{
    $26f5d5cd93fe655a$var$jobOpeningsBlocks.forEach((element)=>{
        module.filtersHandler();
    });
});
/**
 * Testimonials block
 */ const $26f5d5cd93fe655a$var$imageTextBlock = document.querySelectorAll(".praxent_image-text .swiper");

if ($26f5d5cd93fe655a$var$imageTextBlock.length > 0) (parcelRequire("14i02")).then((module)=>{
    $26f5d5cd93fe655a$var$imageTextBlock.forEach((element)=>{
        module.imageTextSlider(element);
    });
});
/**
 * Vertical Slider block
 */ const $26f5d5cd93fe655a$var$verticalSliderBlock = document.querySelectorAll(".praxent_vertical-slider .swiper");

if ($26f5d5cd93fe655a$var$verticalSliderBlock.length > 0) (parcelRequire("6YOpF")).then((module)=>{
    $26f5d5cd93fe655a$var$verticalSliderBlock.forEach((element)=>{
        module.verticalSlider(element);
    });
});
/**
 * Results filters
 */ const $26f5d5cd93fe655a$var$archiveBlock = document.querySelectorAll('.praxent_cando-archive');

if ($26f5d5cd93fe655a$var$archiveBlock.length > 0) (parcelRequire("4rNzL")).then((module)=>{
    $26f5d5cd93fe655a$var$archiveBlock.forEach((element)=>{
        module.handleFilters(element);
    });
});
/**
 * Shrink buttons
 */ // const shrinkableButtons = document.querySelectorAll('.shrink-btn');
// if (shrinkableButtons.length > 0) {
//   import("./shrink-buttons").then((module) => {
//     shrinkableButtons.forEach((element) => {
//       module.handleButton(element);
//     });
//   });
// }
if (document.querySelector(".mobile-nav-trigger")) {
    var $26f5d5cd93fe655a$var$hamburger = document.querySelector(".mobile-nav-trigger");
    var $26f5d5cd93fe655a$var$mobileNavContainer = document.querySelector("div#mobile");
    var $26f5d5cd93fe655a$var$mobileNav = document.getElementById("mobile-menu-container");
    var $26f5d5cd93fe655a$var$closeMobileNavTrigger = document.querySelector("#mobile-close-container #close-button");
    var $26f5d5cd93fe655a$var$mobileSubMenuItems = document.querySelectorAll("#menu-mobile-menu .menu-item");
    var $26f5d5cd93fe655a$var$mobileSubMenuContainers = document.querySelectorAll("#menu-mobile-menu .has-mega-menu");
    document.querySelectorAll("#mobile .submenu-back a").forEach((elem)=>{
        elem.innerHTML = '';
    });
    $26f5d5cd93fe655a$var$handleMobileMenu($26f5d5cd93fe655a$var$hamburger, $26f5d5cd93fe655a$var$mobileNavContainer, $26f5d5cd93fe655a$var$mobileNav);
    if ($26f5d5cd93fe655a$var$closeMobileNavTrigger) $26f5d5cd93fe655a$var$closeMobileNavTrigger.addEventListener("click", function() {
        $26f5d5cd93fe655a$var$closeMobileNav($26f5d5cd93fe655a$var$hamburger, $26f5d5cd93fe655a$var$mobileNavContainer, $26f5d5cd93fe655a$var$mobileNav);
        document.body.style.overflow = 'auto';
    });
    if ($26f5d5cd93fe655a$var$mobileSubMenuItems) $26f5d5cd93fe655a$var$mobileSubMenuContainers.forEach(function(n, index) {
        var mobileSubMenuTrigger = n.querySelector("a");
        mobileSubMenuTrigger.addEventListener("click", function(o) {
            n.classList.add("mobile-submenu-open");
            n.querySelector(".sub-menu").classList.add("active");
            var activeSubMenu = document.querySelector(".sub-menu.active");
            if (activeSubMenu) {
                var submenuBack = document.querySelector(".mobile-submenu-open .sub-menu.active .submenu-back a");
                // submenuBack.innerHTML = '';
                submenuBack.addEventListener("click", function() {
                    activeSubMenu.classList.remove("active");
                    $26f5d5cd93fe655a$var$handleSubmenuBack();
                });
                var subMenuBackButtons = document.querySelectorAll('.submenu-back-button');
                subMenuBackButtons.forEach(function(button) {
                    button.addEventListener('click', function() {
                        activeSubMenu.classList.remove("active");
                        $26f5d5cd93fe655a$var$handleSubmenuBack();
                    });
                });
            }
            var parentMenu = document.getElementById("menu-mobile-menu");
            if (parentMenu) parentMenu.classList.add("menu-hidden");
            if (!n.querySelector(".sub-menu.active")) {
                o.preventDefault();
                n.innerHTML += "<div id='submenu-back'><button><img src='/wp-content/themes/praxent/webroot/img/caret-right-white.svg' /></button></div>";
            }
            var submenuItems = document.querySelectorAll("#menu-mobile-menu > .menu-item");
            submenuItems.forEach(function(p) {
                p.classList.add("hidden");
            });
        });
    });
}
function $26f5d5cd93fe655a$var$handleMobileMenu(hamburger, mobileNavContainer, mobileNav) {
    var praxentLogo = document.querySelectorAll('#praxent-logo')[1];
    hamburger.addEventListener("click", function() {
        hamburger.classList.toggle("is-active");
        if (hamburger.classList.contains('is-active')) {
            praxentLogo.src = "/wp-content/themes/praxent//assets/images/logo.svg";
            document.body.style.overflow = 'hidden';
        } else {
            praxentLogo.src = "/wp-content/themes/praxent//assets/images/logo.svg";
            document.body.style.overflow = 'auto';
        }
        mobileNavContainer.classList.toggle("menu-open");
        mobileNav.classList.toggle("open");
        if (!mobileNav.classList.contains("open")) $26f5d5cd93fe655a$var$closeMobileNav(hamburger, mobileNavContainer, mobileNav);
    });
}
function $26f5d5cd93fe655a$var$handleSubmenuBack() {
    var parentMenu = document.getElementById("menu-mobile-menu");
    var hiddenSubmenuItems = document.querySelectorAll("#menu-mobile-menu .menu-item.hidden");
    parentMenu.classList.remove("menu-hidden");
    if (hiddenSubmenuItems) hiddenSubmenuItems.forEach(function(i) {
        i.classList.remove("hidden");
        if (i.classList.contains("mobile-submenu-open")) i.classList.remove("mobile-submenu-open");
    });
}
function $26f5d5cd93fe655a$var$closeMobileNav(hamburger, mobileNavContainer, mobileNav) {
    var parentMenu = document.getElementById("menu-mobile-menu");
    var subMenu = document.querySelector(".sub-menu.active");
    var hiddenSubmenuItems = document.querySelectorAll("#menu-mobile-menu .menu-item.hidden");
    hamburger.classList.remove("is-active");
    mobileNavContainer.classList.remove("menu-open");
    mobileNav.classList.remove("open");
    if (parentMenu.classList.contains("menu-hidden")) parentMenu.classList.remove("menu-hidden");
    if (hiddenSubmenuItems) hiddenSubmenuItems.forEach(function(i) {
        i.classList.remove("hidden");
        if (i.classList.contains("mobile-submenu-open")) i.classList.remove("mobile-submenu-open");
    });
    if (subMenu) subMenu.classList.remove("active");
}
var $26f5d5cd93fe655a$var$navMegaMenuAnchors = document.querySelectorAll("#desktop li.has-mega-menu > a, #desktop li.has-single-dropdown > a");
if ($26f5d5cd93fe655a$var$navMegaMenuAnchors) $26f5d5cd93fe655a$var$navMegaMenuAnchors.forEach(function(e, index) {
    e.innerHTML += "<svg aria-hidden='true' data-prefix='fas' data-icon='angle-right' class='mega-menu-caret caret-" + index.toString() + " svg-inline--fa fa-angle-right fa-w-8' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path fill='#fff' d='M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z'></path></svg>";
});
const $26f5d5cd93fe655a$var$progressList = document.querySelector('#progressList');

if ($26f5d5cd93fe655a$var$progressList !== undefined) (parcelRequire("8Mkvx")).then((module)=>{
    module.postProgressBar($26f5d5cd93fe655a$var$progressList);
});

})();
//# sourceMappingURL=app.js.map
